import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import axios from "axios";

import { trackPromise } from "react-promise-tracker";

import { saveAs } from "file-saver";

import { detalhesLink } from "../../services/http/linkCompartilhado";

import { obterPastasArquivosFilhosLinkCompartilhado } from "../../services/http/pastaService";
import { registrarDownloadPasta } from "../../services/http/dashboardService";

import ListagemItensCompartilhado from "../../components/ListagemItensCompartilhado";

import {
  validarVisualizar,
  validarSePassouDaDataDeValidade,
} from "../../services/utils";

import { Spin, Modal, message } from "antd";

import IconeArquivos from "../../components/IconeArquivos";

import CompartilhadoBackgroundSvg from "../../assets/icons/background-compartilhado.svg";
import infoPastaSvg from "../../assets/icons/infoPastaCompartilhada.svg";
import Ppo from "../../assets/icons_/ppoint.svg";
import "./styles.scss";
import logoEmpresa from "../../assets/logoContinental.svg";
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import { CloseOutlined } from "@mui/icons-material";
import lang from "../../assets/idioma/idiomas";
let zip = require("jszip")();

const CompartilhadoDownload = () => {
  const { idUsuario, idLink } = useParams();
  const [arquivoMostrar, setArquivoMostrar] = useState(null);
  const [loading, setLoading] = useState(true);
  const [pastaPaiDowload, setPastaPaiDownload] = useState(null);
  const [pastaPaiAberta, setPastaPaiAberta] = useState(false);
  const [pastasDownload, setPastasDownload] = useState([]);
  const [arquivosDownload, setArquivosDownload] = useState([]);
  const [finalizarDownload, setFinalizarDownload] = useState(false);
  const [dataValidadeVencida, setDataValidadeVencida] = useState(false);
  const [senhaValida, setSenhaValida] = useState(false);
  const [senhaArquivo, setSenhaArquivo] = useState("");
  const [valueSenha, setValueSenha] = useState("");
  const [modalSenha, setModalSenha] = useState(false);
  const [pastaDestino, setPastaDestino] = useState(null);
  const [pastaAtual, setPastaAtual] = useState([]);
  const [dataSource, setDataSource] = useState([]);
  const [isSelectedAll, setSelectedAll] = useState(false);
  const [itensSelecionados, setItensSelecionados] = useState([]);

  useEffect(() => {
    setValueSenha("");
    setSenhaArquivo("");
    const buscarDetalhesLinkAsync = async () => {
      await buscarDetalhesLink();
    };

    if (idLink) {
      buscarDetalhesLinkAsync();
    }
    setPastaPaiAberta(false);
    setPastaDestino(null);
    setPastaAtual([]);
    setDataSource([]);
    setItensSelecionados([]);

    return setArquivoMostrar(null);
  }, []);

  useEffect(() => {
    const buscarDetalhesLinkAsync = async () => {
      await buscarDetalhesLink();
    };

    if (idLink) {
      buscarDetalhesLinkAsync();
    }

    formatarDataSource();
  }, [senhaValida, dataSource]);

  useEffect(() => {
    const download = async () => {
      await finalizarDownloadPasta();

      zip = require("jszip")();
      setPastasDownload([]);
      setArquivosDownload([]);
      setFinalizarDownload(false);
    };

    if (
      pastaPaiDowload &&
      (pastasDownload.length > 0 || arquivosDownload.length > 0) &&
      finalizarDownload == true
    ) {
      download();
    }

    setFinalizarDownload(false);
  }, [finalizarDownload]);

  const formatarDataSource = () => {
    if (dataSource?.lista?.length > 0) {
      let newDataSource = [...dataSource.lista];

      let newLista = newDataSource.map((item) => {
        if (
          itensSelecionados.length > 0 &&
          itensSelecionados.findIndex((x) => x.id == item.id) >= 0
        ) {
          return {
            ...item,
            checked: true,
          };
        } else {
          return {
            ...item,
            checked: false,
          };
        }
      });
      dataSource.lista = newLista;
      setDataSource(dataSource);
    }
  };

  const validarSenha = () => {
    if (!valueSenha) {
      message.warning(lang.Preencha_a_senha_para_acessar_o_conteudo_do_link);
      return;
    }

    if (String(valueSenha).trim() !== String(senhaArquivo).trim()) {
      message.warning(lang.Senha_incorreta);
      setValueSenha("");
      return;
    }

    if (String(valueSenha).trim() === String(senhaArquivo).trim()) {
      setSenhaValida(true);
      closeModalSenha();
    }
  };

  const showModalSenha = () => {
    setModalSenha(true);
  };
  const closeModalSenha = () => {
    setModalSenha(false);
  };

  const buscarDetalhesLink = async () => {
    const responseDetalhes = await detalhesLink(idLink);

    if (!responseDetalhes.fail && responseDetalhes.data) {
      const { dataValidade, senha } = responseDetalhes.data;

      const resultValidacaoDataVencimento =
        validarSePassouDaDataDeValidade(dataValidade);

      if (resultValidacaoDataVencimento) {
        setDataValidadeVencida(true);
        setLoading(false);
      } else if (senha && !senhaValida) {
        setLoading(false);
        setSenhaArquivo(senha);
        showModalSenha();
        return;
      } else {
        if (responseDetalhes.data.tipo == 1) {
          setLoading(true);

          if (
            validarVisualizar(responseDetalhes.data.extensao) != "nao-suportado"
          ) {
            await arquivoParaBase64(
              responseDetalhes.data,
              responseDetalhes.data.urlArquivo,
              responseDetalhes.data.extensao
            );
          } else {
            let arquivo = {
              tipoVisualizacao: validarVisualizar(
                responseDetalhes.data.extensao
              ),
            };

            let novoArquivo = Object.assign(responseDetalhes.data, arquivo);
            setArquivoMostrar(novoArquivo);
          }

          setLoading(false);
        } else {
          setPastaPaiDownload(responseDetalhes.data);
          setLoading(false);
        }
      }
    }
  };

  const arquivoParaBase64 = async (item, url, extensao) => {
    let response = await axios.create().get(url, {
      responseType: "blob",
    });

    const reader = new FileReader();
    reader.readAsDataURL(response.data);
    reader.onload = () => {
      let base64 = reader.result.replace("octet-stream", extensao);

      let arquivo = {
        base64,
        tipoVisualizacao: validarVisualizar(item.extensao),
      };

      let novoArquivo = Object.assign(item, arquivo);

      setArquivoMostrar(novoArquivo);
    };
  };

  const handleDownload = async () => {
    if (arquivoMostrar != null && arquivoMostrar.tipo == 1) {
      saveAs(arquivoMostrar.urlArquivo, arquivoMostrar.nomeDocumento);
    } else {
      setLoading(true);
      await downloadBuscarItensFilhos(pastaPaiDowload.idPasta);
      setFinalizarDownload(true);
    }
  };

  const montarPastasDownload = (item) => {
    setPastasDownload((prevent) => [...prevent, item]);
  };

  const montarArquivosDownload = (item) => {
    setArquivosDownload((prevent) => [...prevent, item]);
  };

  const downloadBuscarItensFilhos = async (idPasta, itensSelecionados = []) => {
    let arrayResponsePastas = [];
    let arrayResponseArquivos = [];

    if (itensSelecionados.length > 0) {
      itensSelecionados.forEach((element) => {
        if (element.tipo == 0) {
          arrayResponsePastas.push(element);
        } else {
          arrayResponseArquivos.push(element);
        }
      });
    } else {
      const res = await obterPastasArquivosFilhosLinkCompartilhado(
        idUsuario,
        idPasta,
        9999,
        1
      );
      if (!res.fail && res.data) {
        res.data.lista.forEach((element) => {
          if (element.tipo == 0) {
            arrayResponsePastas.push(element);
          } else {
            arrayResponseArquivos.push(element);
          }
        });
      } else {
      }
    }

    if (arrayResponsePastas.length > 0) {
      for (const pasta of arrayResponsePastas) {
        montarPastasDownload(pasta);
        await downloadBuscarItensFilhos(pasta.id);
      }
    }

    if (arrayResponseArquivos.length > 0) {
      for (const itemArquivo of arrayResponseArquivos) {
        if (itemArquivo.urlArquivo) {
          try {
            const arquivoBaixado = await axios
              .create()
              .get(itemArquivo.urlArquivo, {
                responseType: "arraybuffer",
              });

            if (arquivoBaixado.status != 500 && arquivoBaixado.status != 400) {
              if (
                arquivoBaixado.data &&
                String(arquivoBaixado.data).length > 0
              ) {
                let arquivoToBase64;

                arquivoToBase64 = Buffer.from(arquivoBaixado.data, "binary");

                let arquivo = {
                  id: itemArquivo.id,
                  idParent: itemArquivo.idParent,
                  url: itemArquivo.urlArquivo,
                  extensao: itemArquivo.extensao,
                  nome: itemArquivo.nome,
                  nomeOriginal: itemArquivo.nomeOriginal,
                  path: itemArquivo.path,
                  tipoMidia: itemArquivo.tipoMidia,
                  baixado: arquivoToBase64,
                };

                montarArquivosDownload(arquivo);
              }
            } else {
              continue;
            }
          } catch (err) {
            continue;
          }
        }
      }
      return;
    }
  };

  const finalizarDownloadPasta = async () => {
    if (pastaPaiDowload != null) {
      for (const arq1 of arquivosDownload) {
        if (
          arq1.idParent == pastaPaiDowload.idPasta ||
          (pastaPaiAberta && !pastasDownload.find((x) => x.id == arq1.idParent))
        ) {
          try {
            zip.file(arq1.nome, arq1.baixado, { binary: true });
          } catch (err) {
            console.error(err);
            continue;
          }
        }
      }

      for (const pasta of pastasDownload) {
        let folder = await zip.folder(pasta.nome);

        for (const arq2 of arquivosDownload) {
          if (arq2.idParent == pasta.id) {
            try {
              folder.file(arq2.nome, arq2.baixado, { binary: true });
            } catch (err) {
              console.error(err);
            }
          }
        }
      }
    }

    let content = await zip.generateAsync({
      type: "blob",
      compression: "DEFLATE",
      compressionOptions: {
        level: 8,
      },
      streamFiles: true,
    });

    await registrarDownloadPasta(pastaPaiDowload.idPasta);
    saveAs(content, pastaPaiDowload.nomeDocumento);
    setLoading(false);
  };

  const selecionarItem = (e, item) => {
    const indexItem = dataSource?.lista?.findIndex((x) => x.id == item.id);

    if (e) {
      let findExists = itensSelecionados.find((x) => x.id == item.id);
      if (!findExists) {
        dataSource.lista[indexItem].checked = e;
        setDataSource(dataSource);
        setItensSelecionados((prevent) => [...prevent, item]);
      } else {
        return;
      }
    } else {
      dataSource.lista[indexItem].checked = e;
      setDataSource(dataSource);
      let newArray = [...itensSelecionados];

      let index = newArray.findIndex((x) => x.id == item.id);

      if (index >= 0) {
        newArray.splice(index, 1);
        setItensSelecionados(newArray);
      }
    }
  };

  const marcarTodos = (value) => {
    if (value) {
      dataSource?.lista.map((item) => {
        item.checked = value;
      });

      setDataSource(dataSource);
      setSelectedAll(true);
      setItensSelecionados([...dataSource?.lista]);
    } else {
      dataSource?.lista.map((item) => {
        item.checked = value;
      });
      setSelectedAll(false);
      setItensSelecionados([]);
    }
  };

  const changeNavegacao = (idPasta, nomePasta, index) => {
    if (pastaPaiDowload.idPasta === idPasta) {
      setPastaPaiAberta(false);
      setPastaDestino(null);
      setPastaAtual([]);
      setDataSource([]);
      setItensSelecionados([]);
      return;
    }

    let pastas = pastaAtual;
    if (index < pastas.length - 1) {
      for (var i = pastas.length - 1; i > index; i--) {
        pastas.splice(i, 1);
      }
      setPastaAtual(pastas);
    }

    incluirPastaSelecionada(idPasta, nomePasta, 0);
  };

  const handlePastaPaiAberta = (item) => {
    if (item.tipo == 0) {
      setPastaPaiAberta(true);
      incluirPastaSelecionada(item.idPasta, item.nomeDocumento, item.tipo);
    }
  };

  const incluirPastaSelecionada = (idPasta, nomePasta, tipo) => {
    if (tipo == 0) {
      if ((pastaDestino && pastaDestino.id != idPasta) || !pastaDestino) {
        if (pastaAtual.findIndex((x) => x.id == idPasta) < 0) {
          setPastaAtual((prevent) => [
            ...prevent,
            {
              id: idPasta,
              name: nomePasta,
            },
          ]);
        }

        setPastaDestino({
          id: idPasta,
          nome: nomePasta,
        });
      }

      trackPromise(
        obterPastasArquivosFilhosLinkCompartilhado(idUsuario, idPasta, 3, 1)
          .then((res) => {
            if (!res.fail && res.data) {
              setDataSource(res.data);
            }
          })
          .catch((error) => {
            console.error(error);
          })
      );
    }
  };

  const abrirPastasArquivos = (page) => {
    if (pastaDestino && pastaDestino.id != "0") {
      trackPromise(
        obterPastasArquivosFilhosLinkCompartilhado(
          idUsuario,
          pastaDestino.id,
          3,
          page
        )
          .then((res) => {
            if (!res.fail && res.data) {
              setDataSource(res.data);
            }
          })
          .catch((error) => {
            console.error(error);
          })
      );
    }
  };

  const handleDownloadSelecionados = async () => {
    setLoading(true);
    if (itensSelecionados.length <= 0) {
      message.warning(lang.Selecione_pasta_ou_arquivo_para_download);
      setLoading(false);
      return;
    }

    await downloadBuscarItensFilhos(null, itensSelecionados);
    setFinalizarDownload(true);
    abrirPastasArquivos(1);
    setItensSelecionados([]);
  };
  const url = [{ uri: arquivoMostrar?.urlArquivo }];
  return (
    <div style={{ overflow: "hidden", height: "100vh" }}>
      <div className="header-link">
        <img width="180px" className="mb-2" src={logoEmpresa} />
        <span className="ml-5">
          <b>Geely Brand Hub</b>
        </span>
      </div>

      <div className="compartilhado-container">
        <Spin spinning={loading}>
          {dataValidadeVencida && !loading && !senhaValida ? (
            <div className="row compartilhado-content">
              <div className="col-lg-12 col-sm-12 col-md-12 compartilhado-arquivo-pasta">
                <p style={{ color: "#FFFFFF" }}>
                  O link não está mais disponível.
                </p>
              </div>
            </div>
          ) : (
            <div className=" compartilhado-content-card">
              <div
                className={
                  pastaPaiAberta
                    ? "compartilhado-arquivo-list "
                    : "compartilhado-arquivo-pasta"
                }
              >
                {arquivoMostrar &&
                arquivoMostrar.tipoVisualizacao == "nao-suportado" ? (
                  <>
                    <IconeArquivos
                      style={{ width: "100px", height: "100%" }}
                      tamanho={"G"}
                      tipo={arquivoMostrar.extensao}
                    />
                    <span
                      className="informacoes-arquivos-download"
                      style={{ marginTop: "40px" }}
                    >
                      {" "}
                      {arquivoMostrar.nomeDocumento}{" "}
                    </span>
                    <span className="informacoes-arquivos-download">
                      {" "}
                      {arquivoMostrar.tamanho}{" "}
                    </span>
                  </>
                ) : null}
                {arquivoMostrar &&
                arquivoMostrar?.tipoVisualizacao == "power-point" ? (
                  <>
                    <img
                      style={{ width: "99.99px", height: "100%" }}
                      src={Ppo}
                    />
                    <span
                      className="informacoes-arquivos-download"
                      style={{ marginTop: "40px" }}
                    >
                      {" "}
                      {arquivoMostrar.nomeDocumento}{" "}
                    </span>
                    <span className="informacoes-arquivos-download">
                      {" "}
                      {arquivoMostrar.tamanho}{" "}
                    </span>
                  </>
                ) : null}
                {arquivoMostrar &&
                  arquivoMostrar.tipoVisualizacao == "word" && (
                    <DocViewer
                      style={{
                        width: "100%",
                        height: "100%",
                      }}
                      documents={url}
                      pluginRenderers={DocViewerRenderers}
                    />
                  )}
                {arquivoMostrar && arquivoMostrar.tipoVisualizacao == "pdf" ? (
                  <>
                    <embed
                      src={arquivoMostrar.urlArquivo}
                      style={{ width: "100%", height: "90%" }}
                      type="application/pdf"
                    ></embed>

                    <span className="informacoes-arquivos-download">
                      {" "}
                      {arquivoMostrar.nomeDocumento}{" "}
                    </span>
                    <span className="informacoes-arquivos-download">
                      {" "}
                      {arquivoMostrar.tamanho}{" "}
                    </span>
                  </>
                ) : null}

                {arquivoMostrar &&
                arquivoMostrar.tipoVisualizacao == "imagem" ? (
                  <>
                    <div className="divImgPrincipalObter">
                      <img
                        src={arquivoMostrar.base64}
                        alt={arquivoMostrar.nomeDocumento}
                        style={{
                          width: "100%",
                          height: "100%",
                          overflow: "hidden",
                          objectFit: "contain",
                        }}
                      />
                    </div>
                    <div className="divInfos">
                      <span className="informacoes-arquivos-downloadInfo">
                        {" "}
                        {arquivoMostrar.nomeDocumento}{" "}
                      </span>
                      <span className="informacoes-arquivos-downloadInfo">
                        {" "}
                        {arquivoMostrar.tamanho}{" "}
                      </span>
                    </div>
                  </>
                ) : null}

                {arquivoMostrar &&
                arquivoMostrar.tipoVisualizacao == "video" ? (
                  <>
                    <video controls style={{ width: "100%", height: "90%" }}>
                      <source src={arquivoMostrar.urlArquivo}></source>
                    </video>
                    <span className="informacoes-arquivos-download">
                      {" "}
                      {arquivoMostrar.nomeDocumento}{" "}
                    </span>
                    <span className="informacoes-arquivos-download">
                      {" "}
                      {arquivoMostrar.tamanho}{" "}
                    </span>
                  </>
                ) : null}

                {pastaPaiDowload && !pastaPaiAberta && (
                  <div
                    className="col-lg-4 col-md-4 col-sm-12 compartilhado-pasta"
                    onClick={() => handlePastaPaiAberta(pastaPaiDowload)}
                  >
                    <img
                      style={{ width: "100px", height: "100px" }}
                      src={infoPastaSvg}
                    />
                    <span className="informacoes-arquivos-download">
                      {" "}
                      {pastaPaiDowload.nomeDocumento}{" "}
                    </span>
                  </div>
                )}

                {pastaPaiAberta && (
                  <div className="containerTabela">
                    <div className="caminho-pastas">
                      {pastaAtual.map((item, index) => (
                        <button
                          className="pasta-navegacao"
                          key={index}
                          onClick={() =>
                            changeNavegacao(item.id, item.name, index)
                          }
                        >
                          {index != 0 ? (
                            <span style={{ color: "#828282" }}> &gt; </span>
                          ) : null}
                          {`${item.name}`}
                        </button>
                      ))}
                    </div>

                    <ListagemItensCompartilhado
                      data={dataSource}
                      mudarPagina={abrirPastasArquivos}
                      buscarPastasFilhas={incluirPastaSelecionada}
                      selecionarItemParaDownload={selecionarItem}
                      marcarTodosItens={marcarTodos}
                      isSelectAll={isSelectedAll}
                    />
                  </div>
                )}
              </div>
            </div>
          )}
        </Spin>
        <div className={"botao-dowloads-obter mt-3"}>
          {arquivoMostrar || (pastaPaiDowload && !pastaPaiAberta) ? (
            <button
              className="compartilhado-button-download"
              onClick={() => handleDownload()}
            >
              FAZER DOWNLOAD
            </button>
          ) : null}

          {pastaPaiAberta ? (
            <button
              className="compartilhado-button-download"
              onClick={() => handleDownloadSelecionados()}
            >
              FAZER DOWNLOAD
            </button>
          ) : null}
        </div>
        <Modal
          visible={modalSenha}
          className="modal-definir-senha-data"
          // onCancel={closeModalSenha}
          closable={false}
          destroyOnClose={true}
          footer={[]}
        >
          <CloseOutlined
            onClick={closeModalSenha}
            className="custom-close-icon"
          />
          <div className="container-input-senha-data">
            <div>
              <labe>Senha</labe>
              <input
                className="input-senha-confirmar mt-3"
                type="password"
                onChange={(e) => setValueSenha(e.target.value)}
              />
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
              }}
            >
              <button
                className="btn-salvar-senha-confirmar "
                onClick={validarSenha}
              >
                Confirmar
              </button>
            </div>
          </div>
        </Modal>
      </div>
    </div>
  );
};

export default CompartilhadoDownload;
